import "./App.css";
import WordGuess from "./features/WordGuess";

function App() {
  return (
    <div className="App">
      <WordGuess className="words-container" />
    </div>
  );
}

export default App;
